import {
  CREATE_COURIER_ERROR_FAILURE,
  CREATE_COURIER_ERROR_REQUEST,
  CREATE_COURIER_ERROR_SUCCESS,
} from '../../actionConstants';

import apiClient from '../../apiClient';

export const createCourierError = (dispatch, data) =>
  dispatch({
    type: CREATE_COURIER_ERROR_REQUEST,
    payload: apiClient.dashboard.courierError(data).then(
      (res) => {
        dispatch({
          type: CREATE_COURIER_ERROR_SUCCESS,
          successMessage: 'A courier error send',
        });
        return res;
      },
      (err) =>
        dispatch({
          type: CREATE_COURIER_ERROR_FAILURE,
          err,
        }),
    ),
  });
